export default __webpack_public_path__ + "static/media/waterfowl.250b8312.png";